// extracted by mini-css-extract-plugin
module.exports = {"modal":"_5D2-iGPS","image":"_5D2VaAuW","title":"_5D1NBiax","description":"_5D3kzM6b","banner-image":"_5D2ZnLrC","submit-banner":"_5DvywXj-","link":"_5D28WeKH"};